import { c as _c } from "react/compiler-runtime";
import { SortDirection } from "@/entities/ISort";
import { CommunityMembersSortOption } from "@/enums";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
export default function CommunityMembersMobileFilterBar(t0) {
  const $ = _c(7);
  const {
    activeSort,
    sortDirection,
    isLoading,
    onSort
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [CommunityMembersSortOption.LEVEL, CommunityMembersSortOption.TDH, CommunityMembersSortOption.REP, CommunityMembersSortOption.NIC];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const OPTIONS = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      [CommunityMembersSortOption.DISPLAY]: "Profile",
      [CommunityMembersSortOption.LEVEL]: "Level",
      [CommunityMembersSortOption.TDH]: "TDH",
      [CommunityMembersSortOption.REP]: "REP",
      [CommunityMembersSortOption.NIC]: "NIC"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const TITLE = t2 as const;
  let t3;
  if ($[2] !== activeSort || $[3] !== isLoading || $[4] !== onSort || $[5] !== sortDirection) {
    t3 = <div className="tw-flex tw-gap-x-2 sm:tw-hidden tw-overflow-x-auto tw-py-1 tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-transition-colors tw-duration-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300 ">{OPTIONS.map(option => {
        const isActive = option === activeSort;
        const showLoader = isActive && isLoading;
        const arrowDirection = isActive ? sortDirection : SortDirection.DESC;
        return <button key={option} type="button" onClick={() => onSort(option)} className={`group tw-flex tw-items-center tw-justify-center tw-gap-x-1 tw-whitespace-nowrap tw-border-none tw-rounded-full tw-px-3.5 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors tw-duration-200 tw-ease-out ${isActive ? "tw-bg-iron-700 tw-text-white" : "tw-bg-iron-900 tw-text-iron-400 active:tw-bg-iron-700"}`}><span>{TITLE[option]}</span><span className="-tw-mt-0.5 tw-ml-1">{showLoader ? <CircleLoader size={CircleLoaderSize.SMALL} /> : <CommonTableSortIcon direction={arrowDirection} isActive={isActive} activeClassName="tw-text-white" />}</span></button>;
      })}</div>;
    $[2] = activeSort;
    $[3] = isLoading;
    $[4] = onSort;
    $[5] = sortDirection;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}